import{a as r}from"./chunk-RAAYCPUM.js";function o(...e){return r(t,e)}var t=(e,n)=>n>0?e.slice(Math.max(0,e.length-n)):[];export{o as a};
